import { fetchWallpapersNarrow } from '../fetch/documents';
import { createReducer } from './createReducer';
const wallpapersNarrowSlice = createReducer("wallpapersNarrow", fetchWallpapersNarrow, false);


export const selectWallpapersNarrow = (state) => state.wallpapersNarrow.value
export const selectLoadingWallpapersNarrow = (state) => state.wallpapersNarrow.isLoading

export const {} = wallpapersNarrowSlice.actions

export default wallpapersNarrowSlice.reducer

